import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { isEmptyWhitespace } from 'utilities';
import { BaseButtonBlue } from 'components/common_v2/buttons';

export const withReadMore = (Component) => {
  const ReadMoreComponent = ({
    children,
    characterLimit,
    canReadMore,
    ...rest
  }) => {
    const [isOpen, setIsOpen] = useState(false);
    const toggle = () => setIsOpen(!isOpen);

    if (
      isEmptyWhitespace(children)
      || !characterLimit
      || children.length <= characterLimit
    ) {
      return <Component {...rest}>{children}</Component>;
    }

    return (
      <Component {...rest}>
        {isOpen ? children : `${children.substring(0, characterLimit)}...`}
        &nbsp;
        {canReadMore && (
          <BaseButtonBlue
            className="inline"
            style={{ padding: '0px 0px 4px', height: 'inherit' }}
            onClick={toggle}
          >
            {isOpen ? 'show less' : 'read more'}
          </BaseButtonBlue>
        )}
      </Component>
    );
  };

  ReadMoreComponent.propTypes = {
    canReadMore: PropTypes.bool,
    characterLimit: PropTypes.number.isRequired,
    children: PropTypes.string.isRequired,
  };

  ReadMoreComponent.defaultProps = {
    canReadMore: true,
  };

  return ReadMoreComponent;
};
